import React from "react";
import { H5 } from "../../../components/textStyles/style";
import { Chart as ChartJS, ArcElement, Tooltip } from "chart.js";
import { RowBetween } from "../CompanyStat";
import { Typography } from "@mui/material";
import { ageOptions } from "../../../data/SelectOptions";
import { Pie } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register(ArcElement, Tooltip);

const GroupAge = ({ ages, total }) => {
  const colors = [
    "#00796b",
    "#1B4965",
    "#FD7064",
    "#A8C492",
    "#FFCE63",
    "#94CDDB",
    "#d50000",
    "#d500f9",
    "#fb8c00",
    "#4527a0",
    "#ff5722",
    "#263238",
  ];

  const labels = ageOptions.map((el) => el.label);

  const pieDataHandler = () => {
    const d = {
      labels,
      datasets: [
        {
          data: ages,
          backgroundColor: colors,
        },
      ],
    };
    return d;
  };

  const totalHandler = (val) => {
    if (val == 0 || total == 0) {
      return " (0%)";
    } else {
      return ` (${((val / total) * 100).toFixed(0)}%)`;
    }
  };

  return (
    <div>
      <H5 style={{ fontSize: 13, textTransform: 'uppercase', fontWeight: "bold" }} color="#222">
        2.3 Users Per Age
      </H5>
      <div style={{ display: "flex", alignItems: "center" }}>
        <div style={{ width: "100%", marginRight: 20 }}>
          {ageOptions.map((age, i) => {
            if (ages[i] == 0) {
              return null;
            }
            return (
              <RowBetween key={age.value}>
                <Typography style={{ color: "#484848" }} fontSize={13}>
                  {age.label}
                </Typography>
                <Typography fontSize={13} color="#484848">
                  {ages[i]} {totalHandler(ages[i])}
                </Typography>
              </RowBetween>
            );
          })}
          <RowBetween style={{ marginTop: 15 }}>
            <Typography style={{ color: "#484848" }} fontSize={13}>
              Total
            </Typography>
            <Typography fontSize={13} color="#484848">
              {total} (100%)
            </Typography>
          </RowBetween>
        </div>
        <div style={{ maxWidth: 150 }}>
          <Pie
            plugins={[ChartDataLabels]}
            options={{
              plugins: {
                legend: false,
                datalabels: {
                  display: (context) =>
                    context.dataset.data[context.dataIndex] !== 0,
                  formatter: (value, ctx) => {
                    let sum = 0;
                    let dataArr = ctx.chart.data.datasets[0].data;
                    dataArr.map((data) => {
                      sum += data;
                    });
                    let percentage = ((value * 100) / total).toFixed(0) + "%";
                    return percentage;
                  },
                  color: "white", // Label color
                  font: {
                    weight: "bold", // Label font weight
                  },
                },
              },
            }}
            data={pieDataHandler()}
          />
        </div>
      </div>
    </div>
  );
};

export default GroupAge;
